
import { Vue, Component, Prop } from "vue-property-decorator";
import DropdownFilter from "@/components/filters/DropdownFilter.vue";
import DropdownOption from "@/entities/DropdownOption";
import ProjectCriteriaOptions from "@/entities/scheduler/ProjectCriteriaOptions";

@Component({
  components: {
    DropdownFilter,
  },
})
export default class ProjectCriteriaMultiselect extends Vue {
  @Prop({ type: Array, default: () => [] }) value!: DropdownOption[];
  @Prop({ type: Boolean, default: false }) isManager!: boolean;


  commonCriteriaOptions: DropdownOption[] = [{
    name: ProjectCriteriaOptions.PROJECTS_NEEDS_CONTRACTORS,
    id: ProjectCriteriaOptions.PROJECTS_NEEDS_CONTRACTORS,
  }, {
    name: ProjectCriteriaOptions.PROJECTS_WITHOUT_ACTIVITIES,
    id: ProjectCriteriaOptions.PROJECTS_WITHOUT_ACTIVITIES,
  }];

  get criteriaOptions(): DropdownOption[] {
    if (this.isManager) {
      return this.commonCriteriaOptions;
    }
    return [
      ...this.commonCriteriaOptions,
      {
        name: ProjectCriteriaOptions.PROJECTS_WITHOUT_MANAGER,
        id: ProjectCriteriaOptions.PROJECTS_WITHOUT_MANAGER,
      }
    ];
  }

  handleInput(val: DropdownOption[]): void {
    this.$emit("input", val);
  }
}
